// extracted by mini-css-extract-plugin
var _1 = "ExternalSearchPreview-module__animatedBackground--GVY8h";
var _2 = "ExternalSearchPreview-module__container--zyU6x";
var _3 = "ExternalSearchPreview-module__contentContainer--zHmMl";
var _4 = "ExternalSearchPreview-module__emptyContainer--dRs6t";
var _5 = "ExternalSearchPreview-module__footer--okje8";
var _6 = "ExternalSearchPreview-module__icon--GADFd";
var _7 = "ExternalSearchPreview-module__imageContainer--rCw3O";
var _8 = "ExternalSearchPreview-module__title--YEic6";
export { _1 as "animatedBackground", _2 as "container", _3 as "contentContainer", _4 as "emptyContainer", _5 as "footer", _6 as "icon", _7 as "imageContainer", _8 as "title" }
